import React, { useMemo } from "react";
import { Grid, Box, Card, CardContent } from "@mui/material";
import PlotComponent from "../plot/plot";

const Histogram = React.memo(({ data }) => {
  const parsedData = useMemo(() => {
    if (!data?.plot_data || typeof data.plot_data !== "string") return {};
    try {
      return JSON.parse(data.plot_data);
    } catch {
      return {};
    }
  }, [data?.plot_data]);

  const titles = useMemo(() => data?.titles || {}, [data?.titles]);

  const layout = useMemo(
    () => ({
      ...parsedData?.layout,
      height: parsedData?.layout?.height || 380,
      autosize: true,
    }),
    [parsedData?.layout]
  );

  const plotKey = useMemo(() => {
    if (data?.plot_id) return data.plot_id;

    if (data?.plot_data) return `plot-${btoa(data.plot_data).slice(0, 10)}`;

    return `plot-${Date.now()}`;
  }, [data?.plot_id, data?.plot_data]);

  return (
    <Card
      elevation={3}
      sx={{
        mt: 1,
        mb: 1,
        borderRadius: 2,
        overflow: "hidden",
        border: "1px solid #e0e0e0",
        backgroundColor: "#fff",
      }}
    >
      <CardContent sx={{ p: "16px !important" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ p: "8px !important" }}>
            <Box>
              <PlotComponent
                plotKey={plotKey}
                data={parsedData?.data}
                layout={layout}
                config={parsedData?.config}
                plotTitles={titles}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

export default Histogram;
